var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t.return && (u = t.return(), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import React, { useEffect, useMemo, useState } from 'react';
import { Button, Form, Input, Modal, Switch, Upload } from 'antd';
const DEFAULT_ICON_FORM_VALUES = {
    title: '',
    description: '',
    active: true
};
const buildUploadFileList = file => file ? [{
        uid: '-1',
        name: file.name,
        status: 'done'
    }] : [];
export default function DiagnosisIconFormModal({ open, editingIcon, loading = false, getCreateSortOrder, onCancel, onSubmit }) {
    const _Form$useForm = Form.useForm(), _Form$useForm2 = _slicedToArray(_Form$useForm, 1), form = _Form$useForm2[0];
    const _useState = useState(null), _useState2 = _slicedToArray(_useState, 2), selectedImageFile = _useState2[0], setSelectedImageFile = _useState2[1];
    useEffect(() => {
        if (!open)
            return;
        if (editingIcon) {
            form.setFieldsValue({
                title: editingIcon.title || '',
                description: editingIcon.description || '',
                active: editingIcon.active
            });
        }
        else {
            form.setFieldsValue(DEFAULT_ICON_FORM_VALUES);
        }
        form.setFieldValue('image', undefined);
        setSelectedImageFile(null);
    }, [open, editingIcon, form]);
    const imageUploadFileList = useMemo(() => buildUploadFileList(selectedImageFile), [selectedImageFile]);
    const handleOk = () => __awaiter(this, void 0, void 0, function* () {
        var _a;
        const values = yield form.validateFields();
        const isCreate = !editingIcon;
        const payload = {
            title: values.title,
            description: values.description || '',
            sort_order: (_a = editingIcon === null || editingIcon === void 0 ? void 0 : editingIcon.sort_order) !== null && _a !== void 0 ? _a : getCreateSortOrder(),
            active: values.active,
            image: selectedImageFile || undefined
        };
        yield onSubmit(payload, {
            isCreate
        });
    });
    const handleClose = () => {
        form.resetFields();
        form.setFieldValue('image', undefined);
        setSelectedImageFile(null);
        onCancel();
    };
    return /*#__PURE__*/ React.createElement(Modal, {
        open: open,
        title: editingIcon ? 'アイコン編集' : 'アイコン作成',
        onCancel: handleClose,
        onOk: handleOk,
        okText: editingIcon ? '更新' : '作成',
        cancelText: "\u30AD\u30E3\u30F3\u30BB\u30EB",
        confirmLoading: loading,
        destroyOnHidden: true,
        width: 640
    }, /*#__PURE__*/ React.createElement(Form, {
        form: form,
        layout: "vertical",
        initialValues: DEFAULT_ICON_FORM_VALUES
    }, /*#__PURE__*/ React.createElement(Form.Item, {
        label: "\u30BF\u30A4\u30C8\u30EB",
        name: "title",
        rules: [{
                required: true,
                message: 'タイトルを入力してください'
            }]
    }, /*#__PURE__*/ React.createElement(Input, {
        placeholder: "\u8A3A\u65AD\u7D50\u679C\u30BF\u30A4\u30C8\u30EB"
    })), /*#__PURE__*/ React.createElement(Form.Item, {
        label: "\u8AAC\u660E",
        name: "description"
    }, /*#__PURE__*/ React.createElement(Input.TextArea, {
        rows: 3,
        placeholder: "\u30D5\u30ED\u30F3\u30C8\u8868\u793A\u7528\u306E\u8AAC\u660E"
    })), /*#__PURE__*/ React.createElement(Form.Item, {
        label: "\u30B9\u30C6\u30FC\u30BF\u30B9",
        name: "active",
        valuePropName: "checked"
    }, /*#__PURE__*/ React.createElement(Switch, null)), /*#__PURE__*/ React.createElement(Form.Item, {
        label: "\u30A2\u30A4\u30B3\u30F3\u753B\u50CF",
        name: "image",
        required: !editingIcon,
        rules: [{
                validator: () => __awaiter(this, void 0, void 0, function* () {
                    if (!editingIcon && !selectedImageFile) {
                        throw new Error('アイコン画像を選択してください');
                    }
                })
            }]
    }, /*#__PURE__*/ React.createElement(Upload, {
        beforeUpload: file => {
            form.setFieldValue('image', file.name);
            setSelectedImageFile(file);
            return false;
        },
        onRemove: () => {
            form.setFieldValue('image', undefined);
            setSelectedImageFile(null);
        },
        fileList: imageUploadFileList,
        maxCount: 1,
        accept: "image/*"
    }, /*#__PURE__*/ React.createElement(Button, null, "\u753B\u50CF\u3092\u9078\u629E")), (editingIcon === null || editingIcon === void 0 ? void 0 : editingIcon.image_url) && !selectedImageFile ? /*#__PURE__*/ React.createElement("img", {
        src: editingIcon.image_url,
        alt: "current icon",
        className: "mt-3 h-[80px] w-[80px] rounded-lg border border-[#e5e7eb] object-cover"
    }) : null)));
}
